"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openSubWindowWithParams = exports.openSubWindow = exports.openSSObyGet = exports.openSSO = exports.createWindowName = exports.closeAndOpenWindow = void 0;
var _pako = _interopRequireDefault(require("pako"));
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ウィンドウ名を作成する。
 * @param {string} key - ウィンドウ名につけるキー
 */
const createWindowName = key => {
  return key + '_window';
};

/**
 * name,valueの配列からformを作成し、別ウィンドウでポストする。
 * @param {array} data - name,valueの配列
 * @param {string} data.name - フォームのname
 * @param {number|string} data.value - フォームのvalue
 * @param {string} target　- ポスト先URL
 * @param {string} key - ウィンドウ識別キー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 */
exports.createWindowName = createWindowName;
const openSSO = (data, target, key, width, height) => {
  closeAndOpenWindow(key, popupDoc => {
    // フォームを動的に生成
    var html = '<form id="temp_form" method="post" target="_self" action="' + target + '"style="display:none;">';
    for (var x in data) {
      if (data[x] === undefined || data[x] == null) {
        continue;
      }
      var _val = data[x].replace(/'/g, "'");
      html += "<input type='hidden' name='" + x + "' value='" + _val + "' >";
    }
    html += '</form>';
    const body = (0, _jquery.default)(popupDoc.body);
    body.html(html);
    popupDoc.forms[0].submit();
  }, width, height);
};

/**
 * 別ウィンドウを開き、urlをGetする
 * @param {array} url - url
 * @param {string} key - ウィンドウ識別キー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 */
exports.openSSO = openSSO;
const openSSObyGet = (url, key, width, height) => {
  closeAndOpenWindow(key, popupDoc => {
    popupDoc.location.href = url;
  }, width, height);
};

/**
 * 子画面を開く
 * @param {array} url - url
 * @param {string} key - ウィンドウ識別キー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 */
exports.openSSObyGet = openSSObyGet;
const openSubWindow = (url, key, width, height) => {
  return closeAndOpenWindow(key, popupDoc => {
    // urlにmodeを付与し、1：システムのメニューバー無しのウィンドウをオープンする
    popupDoc.location.href = url + '?mode=1';
  }, width, height);
};

/**
 * パラメータ付きで子画面を開く。
 * パラメータは、objectをJSON化し圧縮、base64に変換し送信。
 * jsonに日本語が含まれていた場合、encodeURIComponentをする必要があるが、
 * 文字長が数倍になってしまうため、zlib圧縮しbase64化する。
 * @param {array} url - url
 * @param {string} key - ウィンドウ識別キー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 * @param {object} params - 子画面側のContainerでPropsとして受け取るパラメータ {key1: value1, key2: value2, …}
 * ※送信されるURLの長さは8K程度が上限。
 */
exports.openSubWindow = openSubWindow;
const openSubWindowWithParams = (url, key, width, height, params) => {
  let searchString = '?mode=1';
  if (params) {
    const encParams = JSON.stringify(params);
    try {
      // pako.deflate は Uint8Array を返すので、Base64 に変換
      const deflated = _pako.default.deflate(encParams);
      const deflatedBase64Params = window.encodeURIComponent(btoa(String.fromCharCode(...deflated)));
      searchString += "&params=".concat(deflatedBase64Params);
    } catch (e) {
      console.error('deflate params error.', e);
    }
  }
  return openFixSizeWindow(url + searchString, key, width, height);
};

/**
 * 既存ウィンドウがあれば閉じてからウィンドウをオープンする。
 * @param {string} url- URL
 * @param {string} key - ウィンドウ名につけるキー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 */
exports.openSubWindowWithParams = openSubWindowWithParams;
const closeAndOpenWindow = (key, afterProc, width, height) => {
  let popup = openFixSizeWindow('', key, width, height);
  let popupDoc;
  try {
    popupDoc = popup.document;
    popup.focus();
    if (afterProc !== null) {
      afterProc(popupDoc);
    }
  } catch (e) {
    popup.close();
    setTimeout(popupDoc => {
      popup = openFixSizeWindow('', key, width, height);
      popupDoc = popup.document;
      if (afterProc !== null) {
        afterProc(popupDoc);
      }
    }, 100);
  }
};

/**
 * ウィンドウをオープンする。
 * @param {string} url- URL
 * @param {string} key - ウィンドウ名につけるキー
 * @param {number} width - 横幅
 * @param {number} height - 縦幅
 */
exports.closeAndOpenWindow = closeAndOpenWindow;
const openFixSizeWindow = (url, key, width, height) => {
  const windowName = createWindowName(key);
  let newWidth = 1024;
  let newHeight = 768;
  if (width) {
    newWidth = width;
  }
  if (height) {
    newHeight = height;
  }
  return window.open(url, windowName, 'width=' + String(newWidth) + ', height=' + String(newHeight) + ',menubar=no,scrollbars=yes,resizable=yes');
};